export type BrowserEventListenerApi = {
  addListener: (...args: unknown[]) => void
  removeListener: (...args: unknown[]) => void
}

export const hasBrowserEventListeners = (
  event: unknown,
): event is BrowserEventListenerApi => {
  if (!event || typeof event !== 'object') return false

  const candidate = event as Partial<BrowserEventListenerApi>
  return typeof candidate.addListener === 'function'
    && typeof candidate.removeListener === 'function'
}
